export default "__VITE_ASSET__ff8c4d2a__"